class Str extends String{
    capitalize(){
        return new Str(this.charAt(0).toUpperCase() + this.slice(1));
    }
    singularize(){
        return new Str(this.slice(0,-1));
    }
}
export default Str;